{
	"page": {
		"title": "Sub Agencies",
		"intro": "The committee or agency a card is issued under. Each can belong to an <strong>organization type</strong> — registrars of that type pick from it. Default access is set per category, under Main / Sub Functions.",
		"addSubAgency": "Add sub-agency",
		"count_one": "{{n}} sub-agency",
		"count_other": "{{n}} sub-agencies"
	},
	"filters": {
		"searchLabel": "Name",
		"searchPlaceholder": "Search sub-agencies by name",
		"typeChips": "Organization type",
		"noType": "No type"
	},
	"table": {
		"name": "Name",
		"type": "Type",
		"sport": "Sport",
		"cards": "Cards",
		"scopes": "Group scopes",
		"created": "Created",
		"editLabel": "Edit {{name}}",
		"deleteLabel": "Delete {{name}}",
		"cardsTitle": "Cards issued under this agency",
		"scopesTitle": "User-group scope rows that name this agency"
	},
	"pagination": {
		"summary_one": "{{from}}–{{to}} of {{total}} sub-agency",
		"summary_other": "{{from}}–{{to}} of {{total}} sub-agencies",
		"empty": "No sub-agencies"
	},
	"empty": {
		"filteredTitle": "No sub-agencies match these filters",
		"filteredDescription": "Try a broader search, or clear the filters.",
		"noneTitle": "No sub-agencies yet",
		"noneDescription": "Add the committees and agencies cards will be issued under.",
		"clearFilters": "Clear filters"
	},
	"form": {
		"addTitle": "Add sub-agency",
		"addDescription": "Registrars of the chosen type pick from this list. Default access is set per category, under Main / Sub Functions.",
		"addSubmit": "Add sub-agency",
		"saveChanges": "Save changes",
		"editInUse_one": "{{count}} card is issued under this agency — a rename shows on it immediately.",
		"editInUse_other": "{{count}} cards are issued under this agency — a rename shows on them immediately.",
		"editEmpty": "No cards are issued under this agency yet.",
		"field": {
			"name": "Name",
			"nameHint": "As it should read on lists and cards — Venue Operations, Medical Services.",
			"type": "Organization type",
			"typeHint": "Registrars of this type pick from this sub-agency. Leave blank if none fits.",
			"sportCode": "Sport code",
			"sportCodeHint": "For a national federation: picking it presets the card's sport — AT, AQ."
		},
		"placeholder": {
			"name": "Venue Operations",
			"type": "No type",
			"typeLoading": "Loading types…",
			"sportCode": "AT"
		}
	},
	"delete": {
		"title": "Delete sub-agency",
		"description": "Delete <strong>{{name}}</strong>? This only works while nothing references it — cards or group scopes.",
		"confirm": "Delete sub-agency",
		"deleted": "{{name}} deleted.",
		"failed": "Couldn't delete sub-agency"
	},
	"toast": {
		"added": "{{name}} added.",
		"updated": "{{name}} updated.",
		"addFailed": "Couldn't add sub-agency",
		"updateFailed": "Couldn't update sub-agency"
	},
	"errors": {
		"nameTaken": "A sub-agency with that name already exists.",
		"invalidValue": "Invalid value",
		"invalidType": "That organization type can't be used here."
	},
	"stats": {
		"total": "Sub-agencies",
		"matching": "matching the filters",
		"inUse": "In use",
		"unused": "Unused"
	}
}
